import elementoVisivel from '../dom';

const ACOES = '[data-tour="recursos-acoes-editar-excluir"]';
const EDITAR = '[data-tour="recursos-editar-manifestacao"]';
const EXCLUIR = '[data-tour="recursos-excluir-manifestacao"]';

export default {
  id: 'recursos-editar-excluir',
  kind: 'tour',
  version: 1,
  label: 'Editar ou excluir manifestações',
  contexts: ['auction.recursos'],
  scopes: ['acoes-editar-excluir'],
  priority: 50,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.acoesVisiveis);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.acoesVisiveis) return false;
    return Boolean(elementoVisivel(ACOES) || elementoVisivel(EDITAR) || elementoVisivel(EXCLUIR));
  },
  steps() {
    const steps = [];

    if (elementoVisivel(ACOES)) {
      steps.push({
        element: ACOES,
        popover: {
          title: 'Editar ou excluir',
          description:
            'Enquanto a respectiva janela recursal estiver aberta, você pode alterar ou remover os recursos ou contrarrazões que enviou.',
          side: 'left',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(EDITAR)) {
      steps.push({
        element: EDITAR,
        popover: {
          title: 'Editar',
          description:
            'Abre o formulário de edição para corrigir texto, assunto e anexos antes do fim do prazo.',
          side: 'bottom',
          align: 'end',
        },
      });
    }

    if (elementoVisivel(EXCLUIR)) {
      steps.push({
        element: EXCLUIR,
        popover: {
          title: 'Excluir',
          description:
            'Remove a manifestação. A exclusão exige justificativa e, no caso de recursos, impede novo envio (preclusão consumativa).',
          side: 'bottom',
          align: 'end',
        },
      });
    }

    return steps;
  },
};
